import { render } from "./PresoTable.vue?vue&type=template&id=bb1c7a92&scoped=true"
import script from "./PresoTable.vue?vue&type=script&lang=js"
export * from "./PresoTable.vue?vue&type=script&lang=js"

import "./PresoTable.vue?vue&type=style&index=0&id=bb1c7a92&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\sistema-denuncias\\public\\apps\\presos-politicos\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb1c7a92"]])

export default __exports__